// Website.jsx
import React from 'react';
import './Website.css';
import IllyaPhoto from '../Assets/illya.jpeg';
import feelsLogo from '../Assets/career_logos/feels_logo.jpeg';
import rbcLogo from '../Assets/career_logos/rbc_wealth_management_logo.jpeg';
import snapLogo from '../Assets/career_logos/snap_inc_co_logo.jpeg';
import storyStarLogo from '../Assets/career_logos/story_star_logo.jpeg';
import santasAiLabLogo from '../Assets/career_logos/santas_ai_lab_logo.png';
import aurumCenterLogo from '../Assets/career_logos/aurum_center_logo.svg';
import forwardRuntimeLogo from '../Assets/career_logos/forward_runtime_logo.svg';
import gossipsArtLogo from '../Assets/gossips_art_logo.png';
import stampsLogo from '../Assets/stamps_logo.jpg';
import BrunoProgress from '../Assets/Bruno_the_fox_buterfly_assets/Bruno_eBook_cover_English.jpeg';
import proGroshiLogo from '../Assets/pro_groshi_logo.png';
import sportsLogo from '../Assets/sports_logo.jpg';
import youtubeLogo from '../Assets/youtube_logo.png';
import spanishLogo from '../Assets/spanish_logo.jpg';
import tedxLogo from '../Assets/TEDx-logo-circle.png';
import pickleballLogo from '../Assets/pickleball_logo.jpeg';
import familyTreeLogo from '../Assets/family_tree_logo.png';
import familyRecipeBookLogo from '../Assets/family_recipe_book_logo.png';
import financialPlannerLogo from '../Assets/financial_planner_logo.png';

import valuesFirstPrinciples from '../Assets/values_first_principles.png';
import valuesMagic from '../Assets/values_magic.png';
import valuesLeadership from '../Assets/values_leadership.png';
import valuesVulnerability from '../Assets/values_vulnerability.png';
import valuesSustainability from '../Assets/values_sustainability.png';

import uoftLogo from '../Assets/education_logos/university_of_toronto_logo.jpeg';
import brockLogo from '../Assets/education_logos/brock_university_logo.jpeg';
import naukmaLogo from '../Assets/education_logos/national_university_of_kyiv_mohyla_academy_logo.jpeg';
import uscMarshallLogo from '../Assets/education_logos/usc_marshall_executive_education_logo.png';
import exosGameChangerLogo from '../Assets/education_logos/exos_game_changer_logo.png';
import marsLogo from '../Assets/education_logos/mars_logo.png';
import wordsThatShookTheWorldLogo from '../Assets/education_logos/words_that_shook_the_world_logo.jpg';

import Card from '../Components/Card';
import { useNavigate } from 'react-router-dom';

const Icon = ({ type, status }) => {
    const icons = {
        heart: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
        ),
        sparkles: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
            </svg>
        ),
        pen: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 19l7-7 3 3-7 7-3-3z" />
                <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
            </svg>
        ),
        mic: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
                <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
        ),
        camera: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                <circle cx="12" cy="13" r="4" />
            </svg>
        ),
        message: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
        ),
        brain: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 3c1.5 0 2.5 1 3 2 1.5 0 3 1.5 3 3 2 0 3 1.5 3 3s-1 3-3 3c0 1.5-1.5 3-3 3-0.5 1-1.5 2-3 2s-2.5-1-3-2c-1.5 0-3-1.5-3-3-2 0-3-1.5-3-3s1-3 3-3c0-1.5 1.5-3 3-3 0.5-1 1.5-2 3-2z" />
                <path d="M12 8c1.5 0 2.5 0.5 3 1.5 1 0 2 1 2 2s-1 2-2 2c-0.5 1-1.5 1.5-3 1.5s-2.5-0.5-3-1.5c-1 0-2-1-2-2s1-2 2-2c0.5-1 1.5-1.5 3-1.5z" />
            </svg>
        ),
        mail: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
            </svg>
        ),
        phone: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
        ),
        stethoscope: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 15c0-1 .5-2 2-2s2 1 2 2-.5 2-2 2-2-1-2-2z" />
                <path d="M6 17v1a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-1" />
                <path d="M8 15c0-3.5 1-6.5 3-7" />
                <path d="M16 15c0-3.5-1-6.5-3-7" />
                <path d="M11 8V3" />
                <path d="M13 8V3" />
                <path d="M16 15a2 2 0 1 0 4 0 2 2 0 0 0-4 0z" />
            </svg>
        ),
        doctor: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">
                <path d="M9.33333 10.6667V13.3333C9.33333 17.0152 12.3181 20 16 20M9.33333 10.6667H22.6667M9.33333 10.6667V8.00001C9.33333 6.52824 10.5282 5.33334 12 5.33334H20C21.4718 5.33334 22.6667 6.52824 22.6667 8.00001V10.6667M16 20C19.6819 20 22.6667 17.0152 22.6667 13.3333V10.6667M16 20H20M16 20H12M20 24V20M20 24C21.1058 24 22.0022 24.8964 22.0022 26.0022V26.6667M20 24C18.8942 24 17.9979 24.8964 17.9979 26.0022V26.6667M20 20C23.6819 20 26.6667 22.9848 26.6667 26.6667M12 24V20M12 20C8.31811 20 5.33335 22.9848 5.33335 26.6667M13.3394 25.3333C13.3394 26.0697 12.7424 26.6667 12.006 26.6667C11.2696 26.6667 10.6727 26.0697 10.6727 25.3333C10.6727 24.597 11.2696 24 12.006 24C12.7424 24 13.3394 24.597 13.3394 25.3333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        health: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                <path d="M12 6v6" />
                <path d="M9 9h6" />
            </svg>
        ),
        books: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                <path d="M12 6h4" />
                <path d="M12 10h4" />
                <path d="M12 14h4" />
            </svg>
        ),
        finance: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v20" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
        ),
        youtube: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
            </svg>
        ),
        art: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
            </svg>
        ),
        stamp: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M7 7h10" />
                <path d="M7 12h10" />
                <path d="M7 17h10" />
                <circle cx="12" cy="12" r="2" />
            </svg>
        ),
        recipeBook: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                <path d="M8 7h8" />
                <path d="M8 11h8" />
                <path d="M8 15h4" />
                <path d="M12 15v4" />
            </svg>
        ),
    };

    return <div className={`icon icon-${status}`}>{icons[type]}</div>;
};

const DomainLinks = ({ domains, color }) => (
    <span className="card-domains" style={color ? { '--domain-color': color } : undefined}>
        {domains.map((domain, index) => (
            <React.Fragment key={domain}>
                {index > 0 && <span className="card-domains-sep"> · </span>}
                <a
                    href={`https://${domain}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card-domain-link"
                >
                    {domain}
                </a>
            </React.Fragment>
        ))}
    </span>
);

const Main = () => {
    const navigate = useNavigate();
    
    const projects = [
        {
            id: 1,
            title: "Santa's AI Lab",
            subtitle: (
                <>Co-Founder &amp; Founding Engineer<DomainLinks domains={["santasailab.com", "stellafoster.com", "outsideagent.ai"]} /></>
            ),
            status: "past",
            description: "Primary hands-on full-stack engineer across client applications, backend services, data, integrations, reliability, and cloud delivery. Built Stella Foster across voice, SMS, React, native Apple apps, React Native, and Slack for 40,000+ users. Evolved its Node.js and Firestore backend into a TypeScript, PostgreSQL, and Temporal platform, with 15+ integrations and 1,620+ evaluation and red-team cases gating releases.",
            icon: null,
            image: santasAiLabLogo,
            detailHref: '/santas-ai-lab',
            links: [{ label: 'View full experience', href: '/santas-ai-lab' }],
            years: "Oct 2023 to Sep 2026"
        },
        {
            id: 2,
            title: "Feels Music Messaging",
            subtitle: (
                <>Senior Software Engineer &amp; Advisor<DomainLinks domains={["feelsmusic.com"]} color="#262626" /></>
            ),
            status: "past",
            description: "Owned delivery across native iOS, Android, and web for a music messaging product. Built the iOS consumer app and a React and Node.js artist platform hands-on, including media, artwork, content workflows, engagement analytics, and ShazamKit audio recognition. Coordinated Android, moved engineering in-house, helped hire the team, and prototyped machine-learning-assisted search and media synchronization.",
            icon: null,
            image: feelsLogo,
            detailHref: '/experience/feels',
            links: [{ label: 'View full experience', href: '/experience/feels' }],
            years: "Oct 2022 to Oct 2023"
        },
        {
            id: 3,
            title: "Snap Inc.",
            subtitle: "Camera Lead Design Engineer",
            status: "past",
            description: "Designed and built fully functional native prototypes across Camera, Creative Tools, and Memories. The Objective-C Preview Filter Carousel prototype became a launch used by 64M people daily, increasing filter impressions by 38% on iOS and 10% on Android. Built further Swift, Objective-C, and UIKit prototypes, used analytics and research to refine them, and partnered with production engineering through launch and measurement.",
            icon: null,
            image: snapLogo,
            detailHref: '/experience/snap',
            links: [{ label: 'View full experience', href: '/experience/snap' }],
            years: "Apr 2020 to Sep 2022"
        },
        {
            id: 4,
            title: "Story Star",
            subtitle: "Co-Founder & Head of Mobile Development",
            status: "past",
            description: "Built and led development across 20+ consumer iOS and web products spanning social networks, audiobooks, video editing, utilities, and games. Worked across Swift, Firebase, web services, media, analytics, growth, and monetization. The largest reached 250K+ monthly users, the most profitable exceeded $20K per month, and Spotlight was acquired by Snap and became a core Snapchat feature.",
            icon: null,
            image: storyStarLogo,
            detailHref: '/experience/story-star',
            links: [{ label: 'View full experience', href: '/experience/story-star' }],
            years: "Dec 2015 to May 2020"
        },
        {
            id: 5,
            title: "RBC Wealth Management",
            subtitle: "Senior iOS Developer & Tech Lead",
            status: "past",
            description: "Led Objective-C and Swift development for wealth-management applications serving 25,000+ daily users and a business with $463B in assets under management. Worked across product, design, security, compliance, and dependent systems to turn regulated workflows into reliable mobile software and help bring a critical application in-house.",
            icon: null,
            image: rbcLogo,
            detailHref: '/experience/rbc-wealth-management',
            links: [{ label: 'View full experience', href: '/experience/rbc-wealth-management' }],
            years: "Dec 2017 to Apr 2020"
        }
    ];

    const hobbies = [
        {
            id: 'aurum-center',
            title: "AURUM Center",
            subtitle: (
                <>Full-Stack &amp; AI Product Engineering<DomainLinks domains={["aurumcenterusa.com"]} /></>
            ),
            status: "current",
            description: "I am building AURUM Center's multilingual commerce and service platform, including an AI Color Studio that lets customers visualize rooms in new colors, a product catalog and cart, lead capture, and operational integrations.",
            image: aurumCenterLogo,
            detailHref: 'https://www.aurumcenterusa.com',
            links: [{ label: 'Visit AURUM Center', url: 'https://www.aurumcenterusa.com' }]
        },
        {
            id: 'forward-runtime',
            title: "Forward Runtime",
            subtitle: (
                <>AI Voice Operations Platform<DomainLinks domains={["forwardruntime.com"]} /></>
            ),
            status: "current",
            description: "I am building a managed AI voice operations platform that answers business calls around the clock, handles routine requests, books appointments, transfers callers, and writes structured outcomes back to the systems teams already use.",
            image: forwardRuntimeLogo,
            detailHref: 'https://forwardruntime.com',
            links: [{ label: 'Visit Forward Runtime', url: 'https://forwardruntime.com' }]
        },
        {
            id: 1,
            title: "Tennis & Pickleball Community",
            subtitle: "Community Organizer & Coach",
            status: "current",
            description: "Organizing and leading a vibrant community of 20+ players who share a passion for tennis and pickleball. As a community organizer and coach, I run live ball sessions, teach fundamental skills, and coordinate friendly games. Creating an inclusive environment where players of all levels can improve their game while enjoying the social aspects of these sports.",
            icon: "sports",
            image: pickleballLogo,
            links: []
        },
        {
            id: 2,
            title: "Health & Wellness",
            subtitle: "Active Lifestyle",
            status: "current",
            description: "Staying active with tennis, volleyball, pickleball, gym workouts, yoga, and swimming. Taking a holistic approach to health, focusing on eating well, getting good sleep, staying mindful of breathing, and making exercise a regular part of life.",
            icon: "health",
            image: sportsLogo,
            links: []
        },
        {
            id: 3,
            title: "TEDxPacific Avenue",
            subtitle: "Speaker and Event Organizer",
            status: "past",
            description: "Helping organize and curate talented speakers for TEDxPacific Avenue, focusing on bold provocative ideas that will change the world. A platform for sharing innovative ideas and inspiring stories that have the power to transform attitudes, lives, and ultimately, the world.",
            icon: "mic",
            image: tedxLogo,
            links: [{ label: 'Visit Website', url: 'https://www.ted.com/tedx/events/63397' }]
        },
        {
            id: 4,
            title: "Children's Books",
            subtitle: "Author",
            status: "past",
            description: "Author of children's books, including 'Bruno the Fox and the Butterfly' (available in English and Ukrainian). Always open to collaborate with parents, education professionals, illustrators, editors, and publishers.",
            icon: "books",
            image: BrunoProgress,
            links: [
                { label: 'Learn More', onClick: () => navigate('/children-book') }
            ]
        },
        {
            id: 5,
            title: "Pro Groshi Community",
            subtitle: "Financial Education",
            status: "current",
            description: "A community focused on financial education and personal growth. Sharing knowledge and experiences to help others achieve financial freedom.",
            icon: "finance",
            image: proGroshiLogo,
            detailHref: 'https://t.me/+SVsSCUbv85E2Mjky',
            links: [{ label: 'Join Community', url: 'https://t.me/+SVsSCUbv85E2Mjky' }]
        },
        {
            id: 6,
            title: "Financial Systems Research",
            subtitle: "Co-Author",
            status: "past",
            description: "Co-authored a 2019 paper with an IMF consulting advisor exploring how distributed ledgers, smart contracts, and AI could support safer, more transparent banking supervision.",
            icon: "books",
            image: undefined,
            links: []
        },
        {
            id: 7,
            title: "Financial Planning Tool",
            subtitle: "Retirement Calculator",
            status: "past",
            description: "A comprehensive financial planning tool designed to help individuals plan for retirement. Features include investment projections, tax considerations, and lifestyle planning.",
            icon: undefined,
            image: financialPlannerLogo,
            links: [{ label: 'Try Tool', onClick: () => navigate('/financial') }]
        },
        {
            id: 8,
            title: "Financial YouTube",
            subtitle: "Content Creator",
            status: "past",
            description: "Creating educational content about personal finance, investing, and financial independence. Sharing practical advice and strategies for financial success.",
            icon: "youtube",
            image: youtubeLogo,
            links: [{ label: 'Visit Website', url: 'https://www.youtube.com/ibakurov' }]
        },
        {
            id: 9,
            title: "Gossips Art Game",
            subtitle: "Creative Project",
            status: "past",
            description: "An innovative art game that combines creativity with social interaction. A unique platform for artistic expression and community engagement.",
            icon: "art",
            image: gossipsArtLogo,
            links: [{ label: 'Visit Website', url: 'https://gossipsart.com' }]
        },
        {
            id: 10,
            title: "Learning Spanish",
            subtitle: "Language Learning",
            status: "current",
            description: "Aprendiendo español porque me encanta aprender más idiomas. Actualmente hablo cuatro idiomas: ruso, ucraniano, inglés y español. También me encanta la idea de viajar por América Latina y trabajar allí enseñando a niños.",
            icon: "books",
            image: spanishLogo,
            links: []
        },
        {
            id: 11,
            title: "Family Tree",
            subtitle: "Genealogy Project",
            status: "current",
            description: "Building a comprehensive family tree with over 400 individuals, preserving our family history and heritage. Documenting stories, photos, and connections across generations to create a lasting legacy for future generations.",
            icon: undefined,
            image: familyTreeLogo,
            links: []
        },
        {
            id: 12,
            title: "Family Recipe Book",
            subtitle: "Culinary Heritage",
            status: "current",
            description: "Collecting and preserving traditional family recipes, creating a digital cookbook that captures our Ukrainian culinary traditions. Documenting cooking techniques, family stories, and food memories.",
            icon: undefined,
            image: familyRecipeBookLogo,
            links: [{ label: 'View Recipes', onClick: () => navigate('/recipe-book') }]
        },
        {
            id: 13,
            title: "Philately",
            subtitle: "Stamp Collector",
            status: "past",
            description: "Built an extensive collection of over 1,000 Canadian and Ukrainian stamps, showcasing the rich history and cultural heritage of Canada through its postal history.",
            icon: "stamp",
            image: stampsLogo,
            links: []
        }
    ];

    const values = [
        {
            title: "Optimism in Life",
            description: "I choose optimism as my lens to live life. Even the hard moments carry hidden gifts. I believe that (almost) anything is possible, I trust people by default, I believe in the power of kindness, and I see life as a deeply beautiful thing.",
            image: valuesFirstPrinciples
        },
        {
            title: "Acorn Thinking",
            description: "I try to make decisions that will still matter in a hundred years. I plant seeds for systems, products, and communities that will outlive me. Long-term thinking guides how I build and who I build for.",
            image: valuesSustainability
        },
        {
            title: "Radical Curiosity",
            description: "I ask questions others overlook. I dig deep, learn fast, and cross boundaries between disciplines. Curiosity keeps me moving. It fuels my creativity, helps me connect dots, and pushes me to explore the edges of what's possible.",
            image: valuesMagic
        },
        {
            title: "Empowerment Through Knowledge",
            description: "I don't want to hold the answers. I want to help others find their own. I share ideas, frameworks, and tools so people can act with confidence. Empowerment, for me, is about making others more capable.",
            image: valuesLeadership
        },
        {
            title: "Integrity in Creation",
            description: "I care about what I put into the world. I try to build things that are thoughtful, honest, and built to last. I don't chase hype. I focus on usefulness, trust, and the kind of quality that compounds over time.",
            image: valuesVulnerability
        }
    ];

    const education = [
        {
            id: 1,
            logo: wordsThatShookTheWorldLogo,
            school: 'KINN',
            degreeTitle: <>Public Speaking Course with <strong>Richard Greene</strong></>,
            specialization: 'Author of "Words that Shook the World" and renowned speaker who worked with Tony Robbins, Princess Diana, and many others. Completed a 6-week in-person course focused on becoming an incredible and effective speaker.',
            years: 'Oct 2024',
            links: [
                { label: 'Learn more', url: 'http://www.richardgreene.org/' }
            ]
        },
        {
            id: 2,
            logo: uscMarshallLogo,
            school: 'USC Marshall School of Business',
            degreeTitle: <>Leadership Development for Building High Performing Teams. Taught by professor <strong>Dave Logan</strong>, during this course I gained hands-on experience applying organizational design frameworks to real-world leadership and business challenges.</>,
            specialization: '',
            years: 'Sep 2024',
            links: [
                { label: 'Show credential', url: 'https://www.credly.com/badges/1059e561-ffc4-4236-8c17-2dba1f495b1a/public_url' }
            ],
        },
        {
            id: 3,
            logo: exosGameChangerLogo,
            school: 'Exos',
            degreeTitle: 'The Game Changer. A 6-week digital program by Exos that builds self-awareness, personal responsibility, resilience, and adaptability, which empowered me to make a meaningful impact at work and in life. ',
            specialization: '',
            years: 'Mar 2023',
            links: [
                { label: 'Show credential', url: 'https://www.credly.com/badges/e4ea4c5a-2452-4404-8783-3cc59aa2365f' },
                { label: 'Learn more', url: 'https://go.teamexos.com/508-game-changer' }
            ],
        },
        {
            id: 4,
            logo: uoftLogo,
            school: 'University of Toronto',
            degreeTitle: 'Post-Graduate Certificate',
            specialization: 'Financial Analysis & Investment Management',
            years: '2019 - 2020',
            links: []
        },
        {
            id: 5,
            logo: uoftLogo,
            school: 'University of Toronto',
            degreeTitle: 'Post-Graduate Certificate',
            specialization: 'Financial Trading & Option Strategies',
            years: '2018 - 2019',
            links: []
        },
        {
            id: 6,
            logo: marsLogo,
            school: 'MaRS',
            degreeTitle: 'Entrepreneurship 101',
            specialization: '',
            years: 'Jan 2017',
            links: [
                { label: 'Show credential', url: 'https://www.credential.net/10460359' }
            ],
            credentialId: 'Accredible-10460359'
        },
        {
            id: 7,
            logo: brockLogo,
            school: 'Brock University',
            degreeTitle: "Master's of Computer Science",
            specialization: 'Computer Science',
            years: '2015 - 2017',
            links: [
                { label: 'Springer Publication', url: 'https://link.springer.com/chapter/10.1007/978-3-319-77583-8_3' },
                { label: 'Read Thesis', url: 'https://brocku.scholaris.ca/items/eef68d48-0a0b-4c63-a427-54e233e77ce6' }
            ]
        },
        {
            id: 8,
            logo: naukmaLogo,
            school: 'National University of Kyiv-Mohyla Academy',
            degreeTitle: 'Bachelor of Applied Science (B.A.Sc.)',
            specialization: 'Computational and Applied Mathematics',
            years: '2011 - 2015',
            links: []
        }
    ];

    /* const volunteering = [
        {
            id: 1,
            logo: snapLogo,
            organization: 'Snap Inc.',
            title: 'Product Design Mentor',
            period: 'Jun 2021 - Aug 2021 · 3 mos',
            audience: 'Education',
            description: `I was part of an amazing Snap Academy (https://la-tech.org/snap-academies) program and my mentee was Arthur Jensen (https://arthurjensen.myportfolio.com/) who is incredibly talented artist, illustrator and designer. My goals, as a design mentor, were to help him navigate the program, to have lively discussions about the world of product, design, UX, answer any questions that he had about the role, working in the company, interview process, and to provide feedback on the work that he is doing for the Snap Design Academy curriculum. As a result, he has completed 6 projects, worked with other designers, product managers, and engineers, had a chance to chat with our executive team, and have clearly identified his next goals, and priorities in his education and professional career.`
        },
        {
            id: 2,
            logo: teensExploringTechnologyLogo,
            organization: 'URBAN TXT: Teens Exploring Technology',
            title: 'Guest Speaker',
            period: 'Jul 2022 · 1 mo',
            audience: 'Children',
            description: `Explored the topic of "Design: From an Idea to a Product" with 7th-11th graders and helped them understand how to see the idea through to the product. Described what stages does Product Design consist of, and how to use Design Thinking in their startups.`
        },
        {
            id: 3,
            logo: snapLogo,
            organization: 'Snap Inc.',
            title: 'Product Design Mentor',
            period: 'Jun 2022 - Aug 2022 · 3 mos',
            audience: 'Education',
            description: `This is my second year mentoring the very talented students at Snap Design Academy.`
        }
    ]; */

    return (
        <div className="website">
            {/* Hero Section */}
            <header className="hero">
                <div className="container">
                    <div className="hero-content">
                        <img
                            src={IllyaPhoto}
                            alt="Illya"
                            className="hero-logo"
                        />
                        <div className="hero-title">
                            <h1>Illya Bakurov</h1>
                            <p className="hero-tagline">
                                Experienced engineer. Passionate tennis player. Loving father.
                            </p>
                            <div className="hero-links">
                                {/* Portfolio is hidden for now. */}
                                <a href="/resume">Resume</a>
                                <a href="https://x.com/ibakurov" target="_blank" rel="noopener noreferrer">X</a>
                                <a href="https://www.linkedin.com/in/ibakurov" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                <a href="https://github.com/ibakurov" target="_blank" rel="noopener noreferrer">GitHub</a>
                                <a href="mailto:bakurov.illya@gmail.com">Email</a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Experience Section */}
            <section className="career" id="experience">
                <div className="container">
                    <h2>Career Experience</h2>
                    <div className="career-stack">
                        {projects.map((project) => (
                            <Card
                                key={project.id}
                                image={project.image}
                                icon={project.icon ? Icon : undefined}
                                iconType={project.icon}
                                iconStatus={project.status}
                                title={project.title}
                                subtitle={project.subtitle}
                                status={project.status}
                                body={project.description}
                                links={project.links}
                                years={project.years}
                                cardHref={project.detailHref}
                            />
                        ))}
                    </div>

                    <p className="career-earlier">
                        <strong>Earlier:</strong>{' '}
                        <a href="/experience/kinetic-commerce">Senior iOS Developer, Kinetic Commerce (2017)</a>
                        <span aria-hidden="true"> · </span>
                        <a href="/experience/turbo-rocket-games">Gameplay Programmer, Turbo Rocket Games, Kyiv (2016), global winner of the Google AdMob Student App Challenge 2016</a>
                        <span aria-hidden="true"> · </span>
                        <a href="/experience/eventlime">Co-Founder, Eventlime (2015 to 2017)</a>
                        <span aria-hidden="true"> · </span>
                        <a href="/experience/brock-university">Graduate Teaching Assistant, Brock University (2015 to 2017)</a>
                        <span aria-hidden="true"> · </span>
                        <a href="/experience/agency-sm-art">iOS Developer, Agency SM.Art, Kyiv (2014 to 2016)</a>
                    </p>
                </div>
            </section>

            {/* Values Section */}
            <section className="values">
                <div className="container">
                    <h2>My Values</h2>
                    <div className="values-grid">
                        <div className="values-columns">
                            <div className="values-column">
                                {values.slice(0, 2).map((value, index) => (
                                    <div key={index} className="value-item">
                                        <img src={value.image} alt={value.title} className="value-image" />
                                        <div className="value-content">
                                            <h3>{value.title}</h3>
                                            <p>{value.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="values-column">
                                {values.slice(2, 4).map((value, index) => (
                                    <div key={index} className="value-item">
                                        <img src={value.image} alt={value.title} className="value-image" />
                                        <div className="value-content">
                                            <h3>{value.title}</h3>
                                            <p>{value.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="value-item value-item-center">
                            <img src={values[4].image} alt={values[4].title} className="value-image" />
                            <div className="value-content">
                                <h3>{values[4].title}</h3>
                                <p>{values[4].description}</p>
                            </div>
                        </div>
                    </div>
                    <blockquote className="values-quote">
                        "An idea is a gift to you from the universe, an action is a gift from you to the universe"
                    </blockquote>
                </div>
            </section>

            {/* Hobbies Section */}
            <section className="hobbies">
                <div className="container">
                    <h2>Everyday Life</h2>
                    <div className="featured-talks">
                        <h3 className="featured-talks-title">Featured Talks</h3>
                        <div className="talks-grid talks-grid--single">
                            <a
                                className="talk-card"
                                href="https://www.youtube.com/watch?v=HLC00AbmW58"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="talk-thumbnail">
                                    <img
                                        src="https://img.youtube.com/vi/HLC00AbmW58/maxresdefault.jpg"
                                        alt="Can tennis reduce conflicts, and even wars? at TEDxPacific Avenue"
                                    />
                                    <span className="talk-play" aria-hidden="true">▶</span>
                                </div>
                                <h4 className="talk-title">Can tennis reduce conflicts, and even wars?</h4>
                                <p className="talk-event">TEDxPacific Avenue · June 2025</p>
                            </a>
                        </div>
                    </div>
                    <div className="hobbies-grid">
                        {hobbies.map((hobby) => (
                            <Card
                                key={hobby.id}
                                image={hobby.image}
                                icon={Icon}
                                iconType={hobby.icon}
                                iconStatus={hobby.status}
                                title={hobby.title}
                                subtitle={hobby.subtitle}
                                status={hobby.status}
                                body={hobby.description}
                                links={hobby.links}
                                cardHref={hobby.detailHref}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Education Section */}
            <section className="education">
                <div className="container">
                    <h2>Education</h2>
                    <div className="career-grid">
                        {education.map((edu) => (
                            <Card
                                key={edu.id}
                                image={edu.logo}
                                title={edu.school}
                                subtitle={edu.years}
                                body={<>{edu.degreeTitle}{edu.specialization ? <><br />{edu.specialization}</> : null}</>}
                                links={edu.links}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Volunteering and Mentoring Section */}
            {/* <section className="volunteering">
                <div className="container">
                    <h2>Volunteering and Mentoring</h2>
                    <div className="career-grid">
                        {volunteering.map((item) => (
                            <Card
                                key={item.id}
                                image={item.logo}
                                title={item.organization}
                                subtitle={item.period}
                                body={<><strong>{item.title}</strong><br/>{item.description}</>}
                            />
                        ))}
                    </div>
                </div>
            </section> */}

            {/* Contact Section */}
            <section className="contact">
                <div className="container">
                    <h2>Get in Touch</h2>
                    <a href="mailto:bakurov.illya@gmail.com" className="contact-button">Contact Me</a>
                    <div className="social-links-container">
                        <div className="social-links-list">
                            <a href="mailto:bakurov.illya@gmail.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/ibakurov" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                                </svg>
                            </a>
                            <a href="https://twitter.com/ibakurov" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/in/ibakurov" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                                    <rect x="2" y="9" width="4" height="12"></rect>
                                    <circle cx="4" cy="4" r="2"></circle>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <p>{`© ${new Date().getFullYear()} Illya Bakurov`}</p>
                </div>
            </footer>
        </div>
    );
};

export default Main;
